<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.decline_approve_list' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickCancelButton()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<ng-container *ngIf="notifyWarning">
  <span>
    <em [innerHTML]="notifyWarning | translate" class="color-fc1203"></em>
  </span>
</ng-container>
<div style="display: flex;" class="pb-2 py-3">
  <div>
    <span>{{'search_form.decline_batch' | translate}}: </span>
    <span style="color: #fc1203;">{{dataSource.length}}</span>
    <span>{{'search_form.decline_batch_contracts' | translate}}</span>

  </div>

</div>

<!-- </ng-template> -->

<mat-dialog-content>
  <mat-table [dataSource]="dataSource" class="mt-3">
    <!-- STT -->
    <ng-container matColumnDef="STT">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.No' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element, let i = index"
                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        {{i + 1}}
      </mat-cell>
    </ng-container>

    <!-- Tên tài liệu Column -->
    <ng-container matColumnDef="contractName">
      <mat-header-cell *matHeaderCellDef style="max-width: 20%" class="mat-cell-non-boder-right-bottom">
        {{'headertable.document_code_name' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 20%" matTooltip="{{ element.contractName }}"
                class="mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        <span class="fix-width">{{element.contractName}}</span>
      </mat-cell>
    </ng-container>

    <!-- Số file Column -->
    <ng-container matColumnDef="noOfFile">
      <mat-header-cell *matHeaderCellDef style="max-width: 4%" class="mat-cell-non-boder-right-bottom">
        {{'headertable.no_of_files' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 4%"
                class="mat-cell-non-boder-right-bottom number-cell-center"
                (click)="$event.stopPropagation()">
                <span class="fix-width">
                    1
                  <!-- {{element.contractAttachments.length}} -->
                </span>
      </mat-cell>
    </ng-container>

    <!-- Tên các bên ký kết Column -->
    <ng-container matColumnDef="allName">
      <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
        {{'headertable.contract_parties' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
        <span class="fix-width">{{ element.allName}}</span>
      </mat-cell>
    </ng-container>

    <!-- Người chuyển Column -->
    <ng-container matColumnDef="createdUser">
      <mat-header-cell *matHeaderCellDef style="max-width: 18%;" class="mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.forward_by' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 18%;" matTooltip="{{ element.createdUser }}"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
        <span class="fix-width">{{ element.createdUser}}</span>
      </mat-cell>
    </ng-container>

    <!-- Ngày nhận -->
    <ng-container matColumnDef="receivedTime">
      <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom"
                       style="max-width: 12%;">{{'headertable.received_time' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.receivedTime | dateformat }}"
                class="mat-cell-non-border-right-bottom number-cell-center" (click)="$event.stopPropagation()"
                style="max-width: 12%;">
        <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
    </mat-row>
  </mat-table>
  <!-- Pagination -->
</mat-dialog-content>
<mat-divider class="mt-3"></mat-divider>
<mat-dialog-actions align="center">
  <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.cancel' | translate}}
  </button>
  <button mat-raised-button cdkFocusInitial (click)="onClickConfirmButton()" color="primary">
    <mat-icon class="mr-0">done_all</mat-icon>
    {{'button.confirm' | translate}}
  </button>
</mat-dialog-actions>
